import type { TourDefinition } from "../types";
import { welcomeTour } from "./welcomeTour";
import { locationsTour } from "./locationsTour";
import { assetsTour } from "./assetsTour";
import { workOrdersTour } from "./workOrdersTour";
import { inspectionsTour } from "./inspectionsTour";
import { pmSchedulesTour } from "./pmSchedulesTour";

export const tourRegistry: Record<string, TourDefinition> = {
  welcome: welcomeTour,
  locations: locationsTour,
  assets: assetsTour,
  "work-orders": workOrdersTour,
  inspections: inspectionsTour,
  "pm-schedules": pmSchedulesTour,
};
